export function isSizeKey(key) {
  return /(?:size|سایز|اندازه|قطر)/i.test(String(key));
}

export default function SpecValue({ name, value }) {
  const text = String(value ?? '');
  if (!isSizeKey(name)) return text;
  const normalized = /^["″“”]/.test(text.trim()) && !/["″“”]$/.test(text.trim())
    ? `${text.trim().slice(1).trim()}"`
    : text;
  return <bdi dir="ltr" className="inline-block">{normalized}</bdi>;
}
